import React from 'react';

export const RetryIcon = () => (
  <svg height='20' viewBox='0 0 22 20' width='22' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M20 5.535V2a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1h-6a1 1 0 0 1 0-2h3.638l-2.975-2.653a8 8 0 1 0 1.884 8.32 1 1 0 1 1 1.886.666A10 10 0 1 1 5.175 1.245c3.901-2.15 8.754-1.462 11.88 1.667L20 5.535z'
      fill='#FFF'
      fillRule='nonzero'
    />
  </svg>
);
